var home = "https://shopfront-cdn.tekoapis.com/static/03ae0aa735763beb.svg";

export { home as default };
